import type { Document, Documents } from '#domain/Document.ts';

export const dedupeDocumentsById = (documents: Documents): Documents => {
    const deduplicatedDocuments = new Map<string, Document>();

    for (const document of documents) {
        const existing = deduplicatedDocuments.get(document.id);
        if (!existing) {
            deduplicatedDocuments.set(document.id, document);
            continue;
        }

        const mergedAssociations = [...(existing.associations ?? []), ...(document.associations ?? [])].filter(
            (association, index, allAssociations) =>
                allAssociations.findIndex(value => value.id === association.id && value.type === association.type) ===
                index
        );

        deduplicatedDocuments.set(document.id, {
            ...existing,
            associations: mergedAssociations.length ? mergedAssociations : undefined,
        });
    }

    return [...deduplicatedDocuments.values()];
};
